<template>
  <div class="ring" :style="{height:wapperHeight}">
    <div class="ring__title" flex="main:center cross:center">123</div>
    <ve-ring
      style="left:50%;transform:translateX(-50%);"
      :width="ringWidth"
      :height="ringHeight"
      :data="chartData"
      color="#fff"
      :textStyle="textStyle"
      :settings="chartSettings"
      :extend="percentExtend"
    ></ve-ring>
  </div>
</template>

<script>
import VeRing from 'v-charts/lib/ring'

export default {
  components: { VeRing },
  name: 'ringChart',
  data () {
    let clientHeight = document.body.clientHeight - 30
    function getValue (per) {
      return (per * clientHeight) / 100
    }
    this.chartSettings = {
      roseType: 'radius',
      radius: getValue(6),
      offsetY: getValue(8),
      label: {
        show: false
      }
    }
    return {
      wapperHeight: getValue(26) + 'px',
      ringWidth: getValue(22) + 'px',
      ringHeight: getValue(20) + 'px',
      textStyle: {
        color: '#fff',
        fontWeight: 'bold'
      },
      percentExtend: {
        legend: {
          top: getValue(14),
          // right:0,
          icon: 'pin',
          // orient: "vertical",
          textStyle: {
            color: '#fff',
            fontSize: '8'
          }
        }
      },
      chartData: {
        columns: ['日期', '访问用户'],
        rows: [
          { 日期: '1/1', 访问用户: 1393 },
          { 日期: '1/2', 访问用户: 3530 },
          { 日期: '1/3', 访问用户: 2923 },
          { 日期: '1/4', 访问用户: 1723 },
          { 日期: '1/5', 访问用户: 3792 },
          { 日期: '1/6', 访问用户: 4593 }
        ]
      }
    }
  },
  methods: {
    onHandleToggleDate (item, index) {
      this.tooggleDateIndex = index
    }
  }
}
</script>

<style lang="scss" scoped>
.ring {
  background-image: url("../../image/pie.png");
  background-size: 100% 100%;
  background-color: rgba(19, 54, 79, 0);
  color: #fff;
  width: 100%;
  height: 238px;
  touch-action: none;
  &__title {
    height: 0.5rem;
    font-size: 14px;
    font-weight: bold;
  }
}
</style>
